<app-header-one></app-header-one>

<div class="page-title-area page-title-bg1">
    <div class="container">
        <div class="page-title-content">
            <h2>Patient Account</h2>
        </div>
    </div>
</div>

<section class="listing-area pt-100 pb-70">
    <div class="container">
        <div class="section-title">
            <h2>Request's <span class="dashboard-text">Dashboard</span></h2>
        </div>
        <div class="row">
            <table
                mat-table
                [dataSource]="patientBookings"
                class="mat-elevation-z8"
                #table
            >
                <!-- Item Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let booking; let i = index">
                        {{ i + 1 }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Patient's Name</th>
                    <td mat-cell *matCellDef="let booking">
                        {{ booking.patient.name }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nationalID">
                    <th mat-header-cell *matHeaderCellDef>Booking ID</th>
                    <td mat-cell *matCellDef="let booking">
                        {{ booking.booking_id }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="requestDate">
                    <th mat-header-cell *matHeaderCellDef>Request Date</th>
                    <td mat-cell *matCellDef="let booking">
                        {{ booking.created_at | date: "dd/MM/yyyy" }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let booking">
                        <span class="status"> {{ booking.book_status }}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="reply">
                    <th mat-header-cell *matHeaderCellDef>Reply</th>
                    <td mat-cell *matCellDef="let booking">
                        <button mat-menu-item (click)="reply(booking)" *ngIf="booking.havemessage !== 0">
                            <mat-icon style="color: green; padding-top: 5px"
                                >reply</mat-icon
                            >
                            <span style="color: green">Reply</span>
                        </button>
                    </td>
                </ng-container>

                <!-- Disclaimer column -->

                <!-- The table will render two header rows, one data row per data object, and two footer rows. -->
                <tr
                    mat-header-row
                    *matHeaderRowDef="nationalColumnsToDisplay"
                    class="example-first-header-row"
                ></tr>

                <tr
                    mat-row
                    *matRowDef="let row; columns: nationalColumnsToDisplay"
                    (dblclick)="reply(row)"
                >
                    <span></span>
                </tr>
            </table>
        </div>
    </div>
</section>
